<button id="export" type="button" class="btn btn-primary" (click)="export()">
	{{'general.export' | translate}}
</button>
<ng-container *ngIf="exporting">
	<td class="w-20 center text-center">
		<div class="spinner-border"></div>
	</td>
</ng-container>
